import React, { useRef } from "react"
import PropTypes from "prop-types"
import { Typography } from "antd"

import { InvestmentShape } from "@components/Investment/shapes"

import CustomerShape from "../../shapes/CustomerShape"
import PersonalCustomerUpgradeModal from "./PersonalCustomerUpgradeModal"


const PersonalCustomerUpgradeButton = ({
  onSuccess = () => {},
  title,
  customer,
  investment,
}) => {
  const modal = useRef({})

  const onClick = () =>
    modal.current.open()

  const { id: customerId } = customer

  const personalCustomerUpgradeModalProps = {
    modal,
    onSuccess,
    investment,
    customerId,
  }

  return (
    <>
      <Typography.Link onClick={onClick}>
        {title}
      </Typography.Link>

      <PersonalCustomerUpgradeModal
        {...personalCustomerUpgradeModalProps}
      />
    </>
  )
}

PersonalCustomerUpgradeButton.propTypes = {
  title: PropTypes.oneOfType([ PropTypes.string, PropTypes.shape() ]).isRequired,
  customer: CustomerShape.isRequired,
  onSuccess: PropTypes.func,
  investment: InvestmentShape.isRequired,
}

export default PersonalCustomerUpgradeButton
